import { FlexBox } from 'shared/components/Base/FlexBox'
import { EquipmentColor, EquipmentColorHex, EquipmentColorLabel } from 'shared/models/equipment'
import { styled } from 'styled-components'

import { isConsole } from '../../config/config'

export function EquipmentColorBox({ color }: { color: EquipmentColor }) {
  if (!color) return null
  const label = EquipmentColorLabel[color]
  if (color === EquipmentColor.OTHER || !label) return <>{label}</>

  return (
    <FlexBox gap="15px" alignItems="center">
      <OnboardingEquipmentColorBox $color={color} />
      {label}
    </FlexBox>
  )
}

const OnboardingEquipmentColorBox = styled.div<{ $color: EquipmentColor }>`
  width: 10px;
  height: 10px;
  border: 1px solid transparent;
  border-radius: 2px;
  background-color: ${(p) => EquipmentColorHex[p.$color]?.[0]};
  border-color: ${(p) => EquipmentColorHex[p.$color]?.[1]};
  margin-top: ${isConsole() ? 0 : '-3px'};
`
